const OnChangePage = function(page) {
  this.collection.page = page + 1
  this.collection.setCurrentPage(page)
  this.collection.fetchData()
}
export default OnChangePage